<template>
  <b-modal 
    size="md"
    centered
    ref="modal"
    v-if="item"
    @shown="$refs.action && $refs.action.focus()"
  >
    <template #modal-title>
      <i class='bx bx-package'></i>
        <router-link v-if="details" :to="{name: `packages-show`, params: {id: item.id, parent_id: item.shipment_id, exitModal: true}}">
          {{item.barcode}}
        </router-link>
      <status v-bind="{item}" />
    </template>

    <b-overlay :show="loading" rounded spinner-type="grow" spinner-variant="primary">

      <b-container class="clearfix">
        <b-row>
          <b-col :cols=6>
            <dl>
              <value label="shipments.consignee" icon="bx-purchase-tag" :value="item.$shipment.name" />
              <value label="common.phone" icon="bx-phone" :value="item.$shipment.phone" />
              <value label="common.email" icon="bx-envelope" :value="item.$shipment.email" />
            </dl>
          </b-col>
          <b-col :cols=6>
            <dl>
              <value label="merchants.label" icon="bx-cart" :value="item.$shipment.merchant_name" />
              <value label="pudo.packages-in-shipment" icon="bx-package" :value="$tc(`packages.pluralize`,item.$shipment.package_count)" />
              <value v-if="item.driver_id" label="packages.driver" icon="bxs-user" :value="item.driver_name" />
            </dl>
          </b-col>
        </b-row>
      </b-container>

      <template v-if="hasInventory && item.$meta.held_here">
        <b-alert v-if="item.locker_number" show variant="info" class="d-flex flex-column align-items-center mb-4 py-2">
          <span class="my-2">
            {{locationParams.label}} → 
            {{ $t('stores.inventory.rack', {code: locationParams.rack}) }} → 
            {{ $t('stores.inventory.shelf', {code: locationParams.shelf}) }}
          </span>
          <span class="display-4 font-weight-bolder my-2">{{ item.locker_number }}</span>
        </b-alert>
        <b-alert v-else show variant="warning" class="d-flex flex-column align-items-center mb-4 py-2">
          <span class="display-4 font-weight-bolder my-2 text-center">{{ $t('stores.inventory.unassigned') }}</span>
        </b-alert>
      </template>
  
      <b-alert :show="!intended" variant="danger">{{$t('pudo.not-intended')}} ({{ item.dropoff_location_name }})</b-alert>

      <router-link v-if="details" :to="{name: `packages-show`, params: {id: item.id, parent_id: item.shipment_id, exitModal: true}}" class="text-info float-right">
        {{$t('common.details')}} <i class='bx bx-link-alt'></i>
      </router-link>
    </b-overlay>


    <template #modal-footer>
      <b-button v-if="hasInventory && item.$meta.held_here" @click="close('locate')" :variant="item.locker_number ? 'secondary' : 'primary'" class="push-left">{{$t('stores.locate')}}</b-button>
      <template v-if="action">
        <b-button :disabled="loading" @click="close(null)">{{$t('common.cancel')}}</b-button>
        <b-button :disabled="loading" ref="action" variant="primary" @click="perform()">{{$t(`pudo.actions.${action}`)}}</b-button>
      </template>
      <b-button v-else :disabled="loading" @click="close(null)">{{$t('common.ok')}}</b-button>
    </template>
  </b-modal>
</template>

<script>
import Modal from "@/components/Modal"
import Value from "@/components/Value"
import Package from '@/resources/Package'
import Status from '@/components/Status'
import api from '@/api'
import { mapState } from 'vuex'
import Camera from './Camera'
import { accessCheck } from '@/router'
import { FEATURE_INVENTORY } from "@/resources/Location"

export default {
  name: 'PUDOModal',
  extends: Modal,
  components: {Value, Status},
  data() {
    return {
      loading: false,
      details: accessCheck('packages-show')
    }
  },
  props: {
    item: {
      type: Package,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapState('pudo',{
      locationId: 'locationId',
    }),
    action() {
      if(this.item.$meta.actions.checkin) {
        return 'checkin'
      } else if (this.item.$meta.actions.checkout) {
        return 'checkout'
      } else {
        return false
      }
    },
    hasInventory() {
      return !!(this.location?.features & FEATURE_INVENTORY)
    },
    intended() { 
      return this.item.dropoff_location_id === this.locationId
    },
    locationParams() {
      const [zone, rack, shelf] = this.item.locker_number.split('-');

      const label = this.location.layout.find(z => z.code === zone)?.label

      return  {zone, rack, shelf, label}
    }

  },
  methods: {
    async perform() {
      this.loading = true
      await this[this.action]()
      this.loading = false
    },
    async checkin() {
      let confirm = true

      if(!this.intended) {
        confirm = await this.$bvModal.msgBoxConfirm(this.$t('pudo.actions.checkin-confirm'),{
          cancelTitle: this.$t('common.cancel'),
          okTitle: this.$t('pudo.actions.checkin'),
          okVariant: 'danger'
        })
      }

      if(confirm) {
        const { data } = await api.put(`pudo/${this.locationId}/checkin/${this.item.id}`)
        console.log('checkin',data)
      }

      this.close(confirm ? 'checkin' : false)
    },
    async checkout() {
      const imageData = await this.$modal(Camera)
      if(imageData) {
        await api.put(`pudo/${this.locationId}/checkout/${this.item.id}`,{imageData})
        this.close('checkout')
      } else {
        this.close(false)
      }
    },
  }
}
</script>